import ApiRequest from "../index"

const faqRequest = {
  getFaq: async () => ApiRequest.get("/v2/lojinha/complements/faq"),
  putFaq: async data => ApiRequest.put("/v2/lojinha/complements/faq", { ...data })
}

export default faqRequest
